module.exports = __webpack_public_path__ + "static/media/floor1.ee431f72.jpg";